var render = function (_h,_vm) {var _c=_vm._c;return _c('h2',{staticClass:"subtitle-2 text-uppercase mb-3",domProps:{"textContent":_vm._s(_vm.props.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }